import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactSection } from "@/components/ContactSection";

export default function Contact() {
  return (
    <main className="bg-[#F6F4F0] text-[#1F1E1B] antialiased">
      <Navbar />
      <div className="pt-24 lg:pt-28">
        <ContactSection />
      </div>
      <Footer />
    </main>
  );
}
